import Skeleton from 'react-loading-skeleton';

export const PartnerLandingHeroSkeleton = () => {
  return (
    <div className='bg-white px-4 pb-16 pt-0 sm:px-8 sm:pb-20'>
      <section className='mx-auto max-w-[1216px] overflow-hidden rounded-b-[28px] border border-t-0 border-gray-100 bg-gray-50 px-6 py-10 shadow-sm sm:px-10 sm:py-12 lg:px-14'>
        <div className='grid items-center gap-10 lg:grid-cols-[minmax(0,460px)_1fr] lg:gap-12'>
          <div className='max-w-[420px]'>
            <Skeleton width={220} height={48} />
            <div className='mt-8'>
              <Skeleton count={2} height={56} />
            </div>
            <div className='mt-5'>
              <Skeleton count={3} height={28} />
            </div>
            <div className='mt-8'>
              <Skeleton width={160} height={48} borderRadius={12} />
            </div>
          </div>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-[1fr_1.08fr] md:gap-0'>
            <Skeleton height={320} borderRadius={28} />
            <Skeleton height={320} borderRadius={28} />
          </div>
        </div>
      </section>
      <section className='mx-auto mt-10 max-w-[1216px] border-t border-gray-100 pt-10 sm:mt-14 sm:pt-14'>
        <div className='grid gap-8 lg:grid-cols-[minmax(0,520px)_1fr] lg:items-center lg:gap-12'>
          <Skeleton height={320} borderRadius={24} />
          <div>
            <Skeleton width={320} height={44} />
            <div className='mt-5'>
              <Skeleton count={2} height={28} />
            </div>
            <div className='mt-8'>
              <Skeleton count={3} height={24} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
